import React, { useState } from 'react';
import { useTheme } from 'styled-components';
import { Tabs } from 'antd';
import { useTranslate } from '@/translations';
import { Title, faShip, PageContainer } from '@/ui/components';
import { useAppCustomers } from '@/hooks';
import { LiveVesselMap } from './components/LiveVesselMap/LiveVesselMap';
import { ManifestsTab } from './components/ManifestsTab';
import { PortCallsTab } from './components/PortCallsTab';
import { ReferenceDataManagement } from './components/ReferenceDataManagement';

export const Vessel = () => {
  const { t } = useTranslate();
  const { vesselsLink } = useTheme();
  const { hasSuperAdminAccess, hasVesselOperateAccess } = useAppCustomers();
  const [tab, setTab] = useState('map');
  const [vesselName, setVesselName] = useState<string>();

  return (
    <PageContainer>
      <Title title={t('vesselTitle')} icon={faShip} color={vesselsLink} />

      <Tabs
        activeKey={tab}
        onChange={setTab}
        items={[
          {
            key: 'map',
            label: t('liveVesselMap'),
            children:
              tab === 'map' ? (
                <LiveVesselMap
                  canOperate={hasVesselOperateAccess}
                  onOpenManifests={(name) => {
                    setVesselName(name);
                    setTab('manifests');
                  }}
                />
              ) : null,
          },
          {
            key: 'portCalls',
            label: t('portCallsAndDischarge'),
            children:
              tab === 'portCalls' ? (
                <PortCallsTab
                  canOperate={hasVesselOperateAccess}
                  onAddManifest={(vesselName) => {
                    if (vesselName) setVesselName(vesselName);
                    setTab('manifests');
                  }}
                />
              ) : null,
          },
          {
            key: 'manifests',
            label: t('manifests'),
            children:
              tab === 'manifests' ? (
                <ManifestsTab
                  vesselName={vesselName}
                  canOperate={hasVesselOperateAccess}
                  onViewPortCalls={() => setTab('portCalls')}
                  onViewVessel={() => setTab('map')}
                />
              ) : null,
          },
          ...(hasSuperAdminAccess
            ? [
                {
                  key: 'vesselReferenceData',
                  label: t('vesselReferenceData'),
                  children: <ReferenceDataManagement />,
                },
              ]
            : []),
        ]}
      />
    </PageContainer>
  );
};
